export default {
  copyright: '© Copyright 2018. All right reserved.',
  terms: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  data_security: 'Data security information',
  manage_cookies: 'Manage cookies',
};
